import React from "react";
import { Route, Switch } from "react-router-dom";
import MenuBar from "./components/MenuBar";
import MyVotes from "./pages/MyVotes";
import UserGuide from "./pages/UserGuide";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import IDCVotes from "./pages/IDCVotes";

const Layout = () => {
  return (
    <React.Fragment>
      <MenuBar />
      <Switch>
        <Route path="/voting/indashyikirwa" component={MyVotes} />
        <Route path="/voting/idc" component={IDCVotes} />

        <Route path="/voting/user-guide" component={UserGuide} />

        <Route
          children={() => <Redirect to={`/voting/indashyikirwa`} />}
          path="/voting"
        />
      </Switch>
    </React.Fragment>
  );
};

export default Layout;
